import React from 'react'
import { useRouter } from 'next/router'
import Image from 'next/legacy/image'
// Components
import BasicHeadSeo from '@/components/basicHeadSeo'
import Button from '@/components/newButton/Button'
import Loader from '@/components/newLoader/Loader'
import Header from '@/components/newHeader/Header'
import Footer from '@/components/newFooter/newFooter'
// Styles
import styles from './why.module.scss'

export default function WhyMawooPets() {
  const router = useRouter()

  return (
    <>
      <BasicHeadSeo
        title="Should I Buy a Pet from Mawoo Pets? | MawooPets.com"
        description="Here’s a rundown of what makes Mawoo Pets the perfect place to find your family companion — from excellent customer service, to flexible payment options, learn what makes Mawoo Pets stand out!"
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/why-mawoo-pets`}
      />
      <main className={styles.main}>
        {router.isFallback && (
          <div className={styles.loader}>
            <Loader theme="tall" />
          </div>
        )}

        <Header />
        <div>
          <section className={styles.sectionHeader}>
            <div className={styles.containerHeader}>
              <div className={styles.imageDesktop}>
                <Image
                  src="/whyMawoo/img-header-desktop.png"
                  alt="Lady kissing her brown dachshund puppy"
                  layout="responsive"
                  width={1074}
                  height={250}
                  quality={100}
                  objectFit="cover"
                />
              </div>
              <div className={styles.imageMobile}>
                <Image
                  src="/whyMawoo/img-header-mobile.png"
                  alt="Lady kissing her brown dachshund puppy"
                  layout="responsive"
                  width={400}
                  height={200}
                  quality={100}
                  objectFit="cover"
                />
              </div>

              <div className={styles.containerTitle}>
                <h1 className={styles.title}>Why Mawoo Pets?</h1>
              </div>
            </div>
          </section>
          <section className={styles.introduction}>
            <div className={styles.container}>
              <h2>Your Partner in Pet Ownership</h2>
              <p>
                It's one thing to talk to talk, and another to walk the walk! At
                Mawoo Pets, we work every day to make our mission of a future
                where every pet has a home a reality.
                <br />
                <br />
                From when you first interact with us, will see that our team is
                here to support you in the journey of finding and raising your
                new pet. We take this job seriously and are honored to be on the
                journey of pet parenting with you.
              </p>
            </div>
          </section>
          <div className={styles.content}>
            <section className={styles.listReason}>
              <div className={styles.reasonR}>
                <div className={styles.text}>
                  <h3>Unmatched Matching</h3>
                  <p>
                    Our team will find the best-matched puppy for your
                    lifestyle. Our vast network of reputable breeders across the
                    U.S. and Canada supports over 150 breeds, ensuring that you
                    find a pet that is a true match for your life and lifestyle.
                    Not sure where to start? Try our{' '}
                    <a
                      className={styles.link}
                      href={`${process.env.NEXT_PUBLIC_ROOT_URL}/dog-breed-quiz`}
                    >
                      Breed Match Quiz.
                    </a>
                  </p>
                </div>
                <div className={styles.image}>
                  <Image
                    src="/whyMawoo/img-reason1.svg"
                    alt=""
                    layout="responsive"
                    width={50}
                    height={30}
                    quality={100}
                    objectFit="cover"
                  />
                </div>
              </div>
              <div className={styles.reasonL}>
                <div className={styles.image}>
                  <Image
                    src="/whyMawoo/img-reason2.svg"
                    alt=""
                    layout="responsive"
                    width={50}
                    height={30}
                    quality={100}
                    objectFit="cover"
                  />
                </div>
                <div className={styles.text}>
                  <h3>Pay Later Options</h3>
                  <p>
                    We understand that adopting a new puppy is a significant
                    financial commitment. To make this process easier for you,
                    we offer flexible 'Pay Later' options.{' '}
                    <a
                      className={styles.link}
                      href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppy-financing`}
                    >
                      Learn more.
                    </a>
                  </p>
                </div>
              </div>
              <div className={styles.reasonR}>
                <div className={styles.text}>
                  <h3>Health Guarantee</h3>
                  <p>
                    Every puppy at Mawoo Pets comes with a health guarantee to
                    make sure your new friend is protected. And our network of
                    breeders is trained to follow the highest standards of
                    breeding.
                  </p>
                </div>
                <div className={styles.image}>
                  <Image
                    src="/whyMawoo/img-reason3.svg"
                    alt=""
                    layout="responsive"
                    width={50}
                    height={30}
                    quality={100}
                    objectFit="cover"
                  />
                </div>
              </div>
              <div className={styles.reasonL}>
                <div className={styles.image}>
                  <Image
                    src="/whyMawoo/img-reason4.svg"
                    alt=""
                    layout="responsive"
                    width={50}
                    height={30}
                    quality={100}
                    objectFit="cover"
                  />
                </div>
                <div className={styles.text}>
                  <h3>Vet Checks and Deworming</h3>
                  <p>
                    Your peace of mind matters to us. Prior to adoption, all our
                    puppies go through a complete veterinary check and are
                    cleared; they come to your home up to date on vaccinations
                    and deworming.
                  </p>
                </div>
              </div>
              <div className={styles.reasonR}>
                <div className={styles.text}>
                  <h3>Customer Excellence</h3>
                  <p>
                    We are honored to have received such positive feedback from
                    our customers. We are rated 4.8/5.0 on Trustpilot and have a
                    perfect score of 5/5 on the Better Business Bureau (BBB).
                    This brings us immense joy and a sense of pride.
                  </p>
                </div>
                <div className={styles.image}>
                  <Image
                    src="/whyMawoo/img-reason5.svg"
                    alt=""
                    layout="responsive"
                    width={50}
                    height={30}
                    quality={100}
                    objectFit="cover"
                  />
                </div>
              </div>
              <div className={styles.reasonL}>
                <div className={styles.image}>
                  <Image
                    src="/whyMawoo/img-reason6.svg"
                    alt=""
                    layout="responsive"
                    width={50}
                    height={30}
                    quality={100}
                    objectFit="cover"
                  />
                </div>
                <div className={styles.text}>
                  <h3>Doorstep Delivery</h3>
                  <p>
                    We know that your perfect pet may not be a driving distance
                    from your home. That's why we offer USDA licensed and
                    insured delivery of your new puppy right to your doorstep.
                    <a
                      className={styles.link}
                      href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppy-travel`}
                    >
                      Learn more.
                    </a>
                  </p>
                </div>
              </div>
              <div className={styles.reasonR}>
                <div className={styles.text}>
                  <h3>Ongoing Care</h3>
                  <p>
                    Our team's support doesn't stop with finding the right puppy
                    for your home. We are here to help you find a great vet
                    nearby, identify the right food and toys for your puppy, and
                    sign up for top-notch pet insurance. We're committed to the
                    journey of pet journey with you.
                  </p>
                </div>
                <div className={styles.image}>
                  <Image
                    src="/whyMawoo/img-reason7.svg"
                    alt=""
                    layout="responsive"
                    width={50}
                    height={30}
                    quality={100}
                    objectFit="cover"
                  />
                </div>
              </div>
            </section>
            <section className={styles.vision}>
              <h2>Our Guiding Vision</h2>
              <p>
                We imagine a future where every pet has a home, and every home
                has a pet.
                <br />
                <br />
                By choosing Mawoo Pets, you will join us on this vision, and
                help in creating a world where pets and their humans live in joy
                and harmony. We would be honored to have you on this journey
                with us.
              </p>
              <div className={styles.btn}>
                <Button
                  title="Browse Puppies"
                  theme={['green-solid', 'large']}
                  onClick={() => router.push('/search')}
                />
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </main>
    </>
  )
}
